import React, { Component } from "react";
import "./style/Dashboard.css";
import { Layout, Menu, Breadcrumb } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  AppstoreAddOutlined,
  LaptopOutlined,
  BarChartOutlined,
  SettingOutlined,
  UserOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";
import Menubar from "./common/Menubar";
import Product from "./Product/Product";
import Order from "./Order/Order";
import Settings from "./Settings/Settings";
import LivePrices from "./LivePrices/LivePrices";
import User from "./User/User";
import Discount from "./Discount/Discount";

const { Sider } = Layout;

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
      clicked: "Products",
    };

    this.component = null;
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    switch (this.state.clicked) {
      case "Products":
        this.component = <Product />;
        break;

      case "Orders":
        this.component = <Order />;
        break;

      case "Settings":
        this.component = <Settings />;
        break;

      case "Live Prices":
        this.component = <LivePrices />;
        break;

      case "Users":
        this.component = <User />;
        break;

      case "Discount":
        this.component = <Discount />;
        break;

      default:
        break;
    }

    return (
      <>
        <Layout style={{ minHeight: "100vh" }}>
          <Menubar />
          <Layout style={{ paddingTop: "64px" }}>
            <Sider
              trigger={null}
              collapsible
              collapsed={this.state.collapsed}
              width={200}
              className="site-layout-background"
              style={{
                overflow: "auto",
                height: "100%",
                position: "fixed",
                left: 0,
              }}
            >
              <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={["sub1"]}
                defaultOpenKeys={["sub1"]}
                style={{ height: "100%", borderRight: 0 }}
              >
                <Menu.Item
                  key="sub1"
                  onClick={() => this.setState({ clicked: "Products" })}
                  icon={<AppstoreAddOutlined />}
                >
                  Products
                </Menu.Item>
                <Menu.Item
                  key="sub2"
                  onClick={() => this.setState({ clicked: "Orders" })}
                  icon={<LaptopOutlined />}
                >
                  Orders
                </Menu.Item>
                <Menu.Item
                  key="sub3"
                  onClick={() => this.setState({ clicked: "Live Prices" })}
                  icon={<BarChartOutlined />}
                >
                  Live Prices
                </Menu.Item>
                <Menu.Item
                  key="sub4"
                  onClick={() => this.setState({ clicked: "Discount" })}
                  icon={<DollarCircleOutlined />}
                >
                  Discount
                </Menu.Item>
                <Menu.Item
                  key="sub5"
                  onClick={() => this.setState({ clicked: "Users" })}
                  icon={<UserOutlined />}
                >
                  User
                </Menu.Item>
                <Menu.Item
                  key="sub6"
                  onClick={() => this.setState({ clicked: "Settings" })}
                  icon={<SettingOutlined />}
                >
                  Report A Bug
                </Menu.Item>
              </Menu>
            </Sider>
            <Layout
              style={
                this.state.collapsed
                  ? { padding: "0 24px 24px", marginLeft: 80 }
                  : { padding: "0 24px 24px", marginLeft: 200 }
              }
            >
              {/* change */}
              <Breadcrumb style={{ margin: "16px 0" }}>
                {React.createElement(
                  this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                  {
                    className: "trigger",
                    onClick: this.toggle,
                  }
                )}
                <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item>{this.state.clicked}</Breadcrumb.Item>
              </Breadcrumb>

              {this.component}
            </Layout>
          </Layout>
        </Layout>
      </>
    );
  }
}

export default Dashboard;
